<template>
  <v-container class="cmp-booking-templates-booking_templates_sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div class="title" :title="selectedItem && selectedItem.booking_template_name">
            <span>{{ (selectedItem && selectedItem.booking_template_name) || $t('template_name_string') }}</span>
          </div>
        </div>
        <!-- <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <div>
                {{
                  (selectedArtistDetails &&
                    selectedArtistDetails.artist &&
                    selectedArtistDetails.artist.sort_name) ||
                    "Release Artist"
                }}
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <glayout :tabs="tabs">
        <gtab>
          <grow>
            <gcol>
              <gbox :title="$t('template_name')">
                <DBox :id="'cmp-booking-template-sidewindow-overview_info'" :addButton="false" :addLink="false">
                  <div class="form-group">
                    <TextField2 :id="'booking_template_name'" :value="selectedItem.booking_template_name"
                      :placeholder="$t('template_name')" :label="$t('template_name')" @blur="onTextFieldValueChange" />
                    <TextField2 :id="'subject'" :value="selectedItem.subject" :placeholder="$t('subject')"
                      :label="$t('subject')" @blur="onTextFieldValueChange" />
                    <TextField2 :id="'type'" :value="selectedItem.type" :placeholder="$t('type')" :label="$t('type')"
                      @blur="onTextFieldValueChange" bb="0px" />
                  </div>
                </DBox>
              </gbox>
            </gcol>
            <gcol>
            </gcol>
          </grow>
          <grow>
            <gcol f="2">
              <gbox :title="$t('body_text')" :h="editorHeight">
                  <TempalteCodeEditor
                  :value="selectedItem.body_text"
                  @save="value => onTextFieldValueChange({ name:'body_text', value })" />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('template_tag')" :h="editorHeight">
                <BookingTemplatesTag :template-tags="templateTags" component-key-number="1"></BookingTemplatesTag>
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <template v-for="(field, index) in tabFields">
        <gtab :id="field.slice(0, -5)" :title="tabs[index]['value']" v-if="field != 'body_text'" :key="index">
          <grow>
            <gcol f="2">
              <gbox :title="$t('body_text')" :h="editorHeight">
                <TempalteCodeEditor
                  :value="selectedItem[field]"
                  :name="field"
                  @save="value => onTextFieldValueChange({ name:field, value })" />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('template_tag')" :h="editorHeight">
                <BookingTemplatesTag :template-tags="templateTags" :component-key-number="index + 1"></BookingTemplatesTag>
              </gbox>
            </gcol>
          </grow>
        </gtab>
        </template>
        
        <!-- <gtab id="loop1" :title="tabs[1]['value']">
          <grow>
            <gcol f="2">
              <gbox :title="$t('body_text')" :h="editorHeight">
                <TempalteCodeEditor
                  :value="selectedItem.loop1_text"
                  @save="value => onTextFieldValueChange({ name: 'loop1_text', value })" />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('template_tag')" :h="editorHeight">
                <BookingTemplatesTag :template-tags="templateTags" :component-key-number="2"></BookingTemplatesTag>
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="loop2" :title="tabs[2]['value']">
          <grow>
            <gcol f="2">
              <gbox :title="$t('body_text')" :h="editorHeight">
                <TempalteCodeEditor
                  :value="selectedItem.loop1_text"
                  @save="value => onTextFieldValueChange({ name: 'loop2_text', value })" />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('template_tag')" :h="editorHeight">
                <BookingTemplatesTag :template-tags="templateTags" :component-key-number="3"></BookingTemplatesTag>
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="loop3" :title="tabs[2]['value']">
          <grow>
            <gcol f="2">
              <gbox :title="$t('body_text')" :h="editorHeight">
                <TempalteCodeEditor
                  :value="selectedItem.loop1_text"
                  @save="value => onTextFieldValueChange({ name: 'loop3_text', value })" />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('template_tag')" :h="editorHeight">
                <BookingTemplatesTag :template-tags="templateTags" :component-key-number="4"></BookingTemplatesTag>
              </gbox>
            </gcol>
          </grow>
        </gtab> -->
      </glayout>
    </div>
  </v-container>
</template>

<script>
import { BookingStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../../store/types";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import BookingTemplatesTag from "./tags";
import { EventHooks } from "../../../../plugins/text-field";
import { bookingTemplatesService } from "../../services/booking-templates.service";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import TempalteCodeEditor from "./template-code-editor";


export default {
  components: {
    BookingTemplatesTag,
    TempalteCodeEditor
  },
  mixins: [createDTGridHost()],
  data: function () {
    return {
      tabs: [
        { route: "overview", value: this.$t("tab_title_template_overview") },
        {
          route: "loop1",
          value: this.$t("tab_title_template_loop1")
        },
        {
          route: "loop2",
          value: this.$t("tab_title_template_loop2")
        },
        {
          route: "loop3",
          value: this.$t("tab_title_template_loop3")
        },
        {
          route: "loop4",
          value: this.$t("tab_title_template_loop4")
        },
        {
          route: "loop5",
          value: this.$t("tab_title_template_loop5")
        },
        { route: "loop6", value: this.$t("tab_title_template_loop6") },
        { route: "loop7", value: this.$t("tab_title_template_loop7") },
        { route: "loop8", value: this.$t("tab_title_template_loop8") },
        { route: "loop9", value: this.$t("tab_title_template_loop9") },
        { route: "loop10", value: this.$t("tab_title_template_loop10") }
      ],
      // active: -1,
      // selectedTabItem: 0,
      templateStaticTags: [
        {
          action: "date_details",
          title: "Date Details",
          active: true,
          items: [
            { title: "curfew" },
            { title: "date_end" },
            { title: "date_name" },
            { title: "date_start" },
            { title: "date_start_plus_one" },
            { title: "deal_id" },
            { title: "deal_type" },
            { title: "doors_open" },
            { title: "get_in" },
            { title: "line_up" },
            { title: "local_info" },
            { title: "notes" },
            { title: "staff" },
            { title: "ticket_price" },
            { title: "event_url" },
            { title: "startdate_dd" },
            { title: "startdate_mm" },
            { title: "startdate_yyyy" },
            { title: 'startdate_day("en")' },
            { title: 'startdate_day("de")' },
            { title: 'startdate_day("fr")' },
            { title: 'startdate_day("es")' },
            { title: 'startdate_day("pt")' },
            { title: 'startdate_month("en")' },
            { title: 'startdate_month("de")' },
            { title: 'startdate_month("fr")' },
            { title: 'startdate_month("es")' },
            { title: 'startdate_month("pt")' }
          ]
        },
        {
          action: "artist_details",
          title: "Artist Details",
          items: [
            { title: "announce_as" },
            { title: "artist" },
            { title: "artist_account_holder" },
            { title: "artist_bankaccount_no" },
            { title: "artist_bankaddress" },
            { title: "artist_bankname" },
            { title: "artist_bank_details" },
            { title: "artist_before" },
            { title: "artist_iban" },
            { title: "artist_invoice_address" },
            { title: "artist_invoice_address_line" },
            { title: "artist_money_account" },
            { title: "artist_names" },
            { title: "artist_notes" },
            { title: "artist_qty" },
            { title: "artist_short_name" },
            { title: "artist_sortcode" },
            { title: "artist_swift" },
            { title: "artist_tax_id" },
            { title: "artist_url1" },
            { title: "artist_url2" },
            { title: "artist_url3" },
            { title: "artist_vat_id" },
            { title: "cash_on_night" },
            { title: "catering_info" },
            { title: "catering_info2" },
            { title: "commission" },
            { title: "commission_fee" },
            { title: "commission_fee_all_artists" },
            { title: "date_hotel_end_dd" },
            { title: "date_hotel_end_mm" },
            { title: "date_hotel_end_yyyy" },
            { title: 'date_hotel_end_day("en")' },
            { title: 'date_hotel_end_day("de")' },
            { title: 'date_hotel_end_day("fr")' },
            { title: 'date_hotel_end_day("es")' },
            { title: 'date_hotel_end_day("pt")' },
            { title: 'date_hotel_end_month("en")' },
            { title: 'date_hotel_end_month("de")' },
            { title: 'date_hotel_end_month("fr")' },
            { title: 'date_hotel_end_month("es")' },
            { title: 'date_hotel_end_month("pt")' },
            { title: "date_hotel_start_dd" },
            { title: "date_hotel_start_mm" },
            { title: "date_hotel_start_yyyy" },
            { title: 'date_hotel_start_day("en")' },
            { title: 'date_hotel_start_day("de")' },
            { title: 'date_hotel_start_day("fr")' },
            { title: 'date_hotel_start_day("es")' },
            { title: 'date_hotel_start_day("pt")' },
            { title: 'date_hotel_start_month("en")' },
            { title: 'date_hotel_start_month("de")' },
            { title: 'date_hotel_start_month("fr")' },
            { title: 'date_hotel_start_month("es")' },
            { title: 'date_hotel_start_month("pt")' },
            { title: "deposit1" },
            { title: "deposit1_all_artists" },
            { title: "deposit1_duedate" },
            { title: "deposit1_duedate_dd" },
            { title: "deposit1_duedate_mm" },
            { title: "deposit1_duedate_yyyy" },
            { title: 'deposit1_duedate_day("en")' },
            { title: 'deposit1_duedate_day("de")' },
            { title: 'deposit1_duedate_day("fr")' },
            { title: 'deposit1_duedate_day("es")' },
            { title: 'deposit1_duedate_day("pt")' },
            { title: 'deposit1_duedate_month("en")' },
            { title: 'deposit1_duedate_month("de")' },
            { title: 'deposit1_duedate_month("fr")' },
            { title: 'deposit1_duedate_month("es")' },
            { title: 'deposit1_duedate_month("pt")' },
            { title: "deposit2" },
            { title: "deposit2_duedate" },
            { title: "deposit2_duedate_dd" },
            { title: "deposit2_duedate_mm" },
            { title: "deposit2_duedate_yyyy" },
            { title: 'deposit2_duedate_day("en")' },
            { title: 'deposit2_duedate_day("de")' },
            { title: 'deposit2_duedate_day("fr")' },
            { title: 'deposit2_duedate_day("es")' },
            { title: 'deposit2_duedate_day("pt")' },
            { title: 'deposit2_duedate_month("en")' },
            { title: 'deposit2_duedate_month("de")' },
            { title: 'deposit2_duedate_month("fr")' },
            { title: 'deposit2_duedate_month("es")' },
            { title: 'deposit2_duedate_month("pt")' },
            { title: "deposit_info" },
            { title: "expenses_artist" },
            { title: "first_offer" },
            { title: "guarantee_fee" },
            { title: "guarantee_fee_duedate_dd" },
            { title: "guarantee_fee_duedate_mm" },
            { title: "guarantee_fee_duedate_yyyy" },
            { title: 'guarantee_fee_duedate_day("en")' },
            { title: 'guarantee_fee_duedate_day("de")' },
            { title: 'guarantee_fee_duedate_day("fr")' },
            { title: 'guarantee_fee_duedate_day("es")' },
            { title: 'guarantee_fee_duedate_day("pt")' },
            { title: 'guarantee_fee_duedate_month("en")' },
            { title: 'guarantee_fee_duedate_month("de")' },
            { title: 'guarantee_fee_duedate_month("fr")' },
            { title: 'guarantee_fee_duedate_month("es")' },
            { title: 'guarantee_fee_duedate_month("pt")' },
            { title: "guarantee_fee_all_artists" },
            { title: "guarantee_fee_duedate" },
            { title: "guarantee_gross_amount" },
            { title: "guarantee_vat_amount" },
            { title: "guarantee_vat_rate" },
            { title: "guestlist" },
            { title: "guestlist_tickets" },
            { title: "hotel_classification" },
            { title: "hotel_classification2" },
            { title: "hotel_info" },
            { title: "hotel_rooms" },
            { title: "hotel_stars" },
            { title: "single_rooms" },
            { title: "double_rooms" },
            { title: "suites" },
            { title: "performance_time" },
            { title: "performance_time_contract" },
            { title: "performance_type" },
            { title: "person_address1" },
            { title: "person_birthday" },
            { title: "person_city" },
            { title: "person_company" },
            { title: "person_country" },
            { title: "person_email1" },
            { title: "person_fax1" },
            { title: "person_legalname" },
            { title: "person_mobile1" },
            { title: "person_name" },
            { title: "person_passport" },
            { title: "person_phone1" },
            { title: "person_postalcode" },
            { title: "person_vat_id" },
            { title: "person_url1" },
            { title: "profit_share" },
            { title: "stage_name" },
            { title: "schedule_notes" },
            { title: "setup_time" },
            { title: "signature" },
            { title: "soundcheck" },
            { title: "techrider" },
            { title: "techrider2" },
            { title: "travel_info" },
            { title: "travel_info2" },
            { title: "travel_option" },
            { title: "travel_option2" },
            { title: "techrider_url" }
          ]
        },
        {
          action: "promoter_details",
          title: "Promoter Details",
          items: [
            { title: "expenses_promoter" },
            { title: "payment_method" },
            { title: "promoter_address" },
            { title: "promoter_address1" },
            { title: "promoter_address2" },
            { title: "promoter_address_line" },
            { title: "promoter_city" },
            { title: "promoter_region" },
            { title: "promoter_contact" },
            { title: "promoter_contact_phone" },
            { title: "promoter_contact_mobile" },
            { title: "promoter_contact_email" },
            { title: "promoter_contact_vat" },
            { title: "promoter_company" },
            { title: "promoter_legalname" },
            { title: "promoter_country" },
            { title: "promoter_email1" },
            { title: "promoter_emails" },
            { title: "promoter_fax1" },
            { title: "promoter_mobile" },
            { title: "promoter_phone1" },
            { title: "promoter_phones" },
            { title: "promoter_postalcode" },
            { title: "promoter_tax_id" },
            { title: "promoter_vat_id" },
            { title: "promoter_url1" }
          ]
        },
        {
          action: "money_details",
          title: this.$t("money_details"),
          items: [
            { title: "all_in_budget" },
            { title: "all_in_budget_due_date" },
            { title: "all_in_budget_due_date_dd" },
            { title: "all_in_budget_due_date_mm" },
            { title: "all_in_budget_due_date_yyyy" },
            { title: 'all_in_budget_due_date_day("en")' },
            { title: 'all_in_budget_due_date_day("de")' },
            { title: 'all_in_budget_due_date_day("fr")' },
            { title: 'all_in_budget_due_date_day("es")' },
            { title: 'all_in_budget_due_date_day("pt")' },
            { title: 'all_in_budget_due_date_month("en")' },
            { title: 'all_in_budget_due_date_month("de")' },
            { title: 'all_in_budget_due_date_month("fr")' },
            { title: 'all_in_budget_due_date_month("es")' },
            { title: 'all_in_budget_due_date_month("pt")' },
            { title: "all_in_total_artist_income" },
            { title: "booking_fee" },
            { title: "booking_fee_all_artists" },
            { title: "booking_fee_duedate" },
            { title: "booking_fee_duedate_dd" },
            { title: "booking_fee_duedate_mm" },
            { title: "booking_fee_duedate_yyyy" },
            { title: 'booking_fee_duedate_day("en")' },
            { title: 'booking_fee_duedate_day("de")' },
            { title: 'booking_fee_duedate_day("fr")' },
            { title: 'booking_fee_duedate_day("es")' },
            { title: 'booking_fee_duedate_day("pt")' },
            { title: 'booking_fee_duedate_month("en")' },
            { title: 'booking_fee_duedate_month("de")' },
            { title: 'booking_fee_duedate_month("fr")' },
            { title: 'booking_fee_duedate_month("es")' },
            { title: 'booking_fee_duedate_month("pt")' },
            { title: "deal_memo" }
          ]
        },
        {
          action: "travel_details",
          title: "Travel Details",
          items: [
            { title: "travel_artist" },
            { title: "travel_complete" },
            { title: "travel_before" },
            { title: "travel_after" },
            { title: "travel_qty" },
            { title: "travel_costs" },
            { title: "e_ticket" },
            { title: "filekey" },
            { title: "departure_date1" },
            { title: "departure_date2" },
            { title: "departure_time1" },
            { title: "departure_time2" },
            { title: "departure_origin1" },
            { title: "departure_origin2" },
            { title: "carrier1" },
            { title: "carrier2" },
            { title: "carrier_code1" },
            { title: "carrier_code2" },
            { title: "class1" },
            { title: "class2" },
            { title: "arrival_date1" },
            { title: "arrival_date2" },
            { title: "arrival_time1" },
            { title: "arrival_time2" },
            { title: "arrival_destination1" },
            { title: "arrival_destination2" },
            { title: "filekey1" },
            { title: "filekey2" },
            { title: "notes1" },
            { title: "notes2" },
            { title: "e_ticket1" },
            { title: "e_ticket2" }
          ]
        },
        {
          action: "local_details",
          title: "Local Details",
          items: []
        },
        {
          action: "location_details",
          title: "Location Details",
          items: [
            { title: "location_name" },
            { title: "location_address1" },
            { title: "location_address2" },
            { title: "location_postalcode" },
            { title: "location_phone" },
            { title: "location_fax" },
            { title: "location_emails" },
            { title: "location_city" },
            { title: "location_country" },
            { title: "location_urls" },
            { title: "location_capacity" },
            { title: "hotel_start" },
            { title: "hotel_end" }
          ]
        },
        // {
        //   action: "tours",
        //   title: "Tours",
        //   items: [
        //     { title: "booking_tour_name" },
        //     { title: "tour_artist" },
        //     { title: "tour_start_date" },
        //     { title: "tour_end_date" },
        //     { title: "tour_notes" },
        //     { title: "tourbook_leading" },
        //     { title: "tourbook_trailing" },
        //     { title: "tourdate_city" },
        //     { title: "tourdate_notes" }
        //   ]
        // },
        {
          action: "contracts_riders",
          title: "Contracts / Riders",
          items: [
            { title: "expense_amount" },
            { title: "expense_description" },
            { title: "expenses_sum" }
          ]
        },
        {
          action: "contact_details",
          title: "Contact Details",
          items: [
            { title: "contact_payment_provider_data" },
          ]
        },
        {
          action: "other_details",
          title: "Other Details",
          items: [
            { title: "currency" },
            { title: "print_date" },
            { title: "printdate_dd" },
            { title: "printdate_mm" },
            { title: "printdate_yyyy" },
            { title: 'ph.printdate_mm("en")' },
            { title: 'ph.printdate_mm("de")' },
            { title: 'ph.printdate_mm("fr")' },
            { title: 'ph.printdate_mm("es")' },
            { title: 'ph.printdate_mm("pt")' },
            { title: 'ph.printdate_mm("it")' },
            { title: "travel_qty_all_artists" },
            { title: "user_job_title" },
            { title: "*ip_address*", noTag: true },
            { title: "*sign_time*", noTag: true },
            { title: "*promoter_signature*", noTag: true },
            { title: "staff_fullname" },
            { title: "staff_phone1" },
            { title: "staff_phone2" },
            { title: "staff_email" },
            //Loop tags
            ...Array.from({ length: 10 }, (_, i) => ({ title: `loop${i + 1}` }))
          ]
        }
      ],
      tabFields: ['body_text', 'loop1_text', 'loop2_text', 'loop3_text', 'loop4_text', 'loop5_text', 'loop6_text', 'loop7_text', 'loop8_text', 'loop9_text', 'loop10_text'],
    };
  },
  mounted: function () {
  },
  watch: {},
  computed: {
    ...mapGetters(storeNS, {
      templateDetails: "templateDetails",
    }),
    booking_template_id: function () {
      return this.$route.params.booking_template_id;
    },
    customTags: function () {
      const templateDefault = {};
      const selectedTemplateDetails = (this.templateDetails || [])[this.booking_template_id] || templateDefault;
      return { ...selectedTemplateDetails };
    },
    selectedItem: function () {
      return this.customTags?.bookingTemplate ? this.customTags?.bookingTemplate : {};
    },
    templateTags: function () {
      return this.mergeCustomTags();
    },
    editorHeight() {
      const minHeight = 600;
      return minHeight;
    }
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.TemplateDetails.UPDATE.SINGLE]: ActionTypes.TemplateDetails.UPDATE.SINGLE
    }),
    getMapedCustomTags(customTagKeyName) {
      return (this.customTags[customTagKeyName] || []).map(row => {
        return {
          title:
            "custom('" + row.field_label + "','" + row.external_table + "')"
        };
      });
    },
    mergeCustomTags: function () {
      let staticTags = this.templateStaticTags;

      // Date Details  Custom Tags
      staticTags[0].items = staticTags[0].items.concat(
        this.getMapedCustomTags("calendar_dates_custom_tags")
      );

      // Artist Details  Custom Tags
      let calendar_date_artists_custom_tags = this.getMapedCustomTags(
        "calendar_date_artists_custom_tags"
      );
      let artist_custom_tags = this.getMapedCustomTags("artist_custom_tags");
      let artistDetails = calendar_date_artists_custom_tags.concat(
        artist_custom_tags
      );
      staticTags[1].items = staticTags[1].items.concat(artistDetails);

      // Promoter Details  Custom Tags
      staticTags[2].items = staticTags[2].items.concat(
        this.getMapedCustomTags("promoters_custom_tags")
      );

      // Money Details  Invoice tags
      let invoiceTags = [{ title: "invoice('')" }];
      invoiceTags = invoiceTags.concat(
        (this.customTags['invoice_item_names'] || []).map(row => {
          return {
            title: "invoice('" + row.item_name + "')"
          };
        }),
        staticTags[3].items
      );
      staticTags[3].items = invoiceTags;

      // Local Details  local & custom tags
      let localDetailsTags = [];
      (this.customTags.booking_local_details_type_names || []).forEach(row => {
        this.customTags[
          "local_details_elements_" + row.local_details_type_id
        ].forEach(local_details_element => {
          localDetailsTags.push({
            title:
              "locals('" +
              row.local_details_type_name +
              "','" +
              local_details_element +
              "')"
          });
        });

        localDetailsTags = localDetailsTags.concat(
          this.getMapedCustomTags(
            "local_details_cf_" + row.local_details_type_id
          )
        );
      });
      staticTags[5].items = localDetailsTags;

      // Location Details  custom tags
      staticTags[6].items = staticTags[6].items.concat(
        this.getMapedCustomTags("venue_custom_tags")
      );

      // Contact Details  custom tags
      staticTags[8].items = staticTags[8].items.concat(
        this.getMapedCustomTags("contact_custom_tags")
      );

      // this.templateTags = staticTags;
      return staticTags;
    },
    onTextFieldValueChange: function ({ name, value }) {
      // console.log('mdsir:', `${name} - ${value}`);
      this[ActionTypes.TemplateDetails.UPDATE.SINGLE]({ name, value, item: this.selectedItem });

      if (!['booking_template_name', 'subject', 'type'].includes(name)) {
        NotificationService.showNotification({
          text: "Template updated successfully",
        })
      }
    }
  }
};
</script>

<style lang="scss">
.cmp-booking-templates-booking_templates_sidewindow {
  .flex-container {
    display: flex;
  }

  .dt-grid-layout {
    height: calc(100vh - 150px);
  }

}
</style>